import { writable } from "svelte/store"

export const notesStore = writable({
  excludedTypes: [] as string[],
})
